import { Button } from 'antd';
import React, { useContext } from 'react';

import { PREFIX } from '@app/constants';
import { useNewUserAccessRights, useWindowSize } from '@app/hooks';
import { HeaderContext } from '@app/providers';

const CREATE_SALES_FUNNEL = 'Создать воронку продаж';

export const SalesFunnelsPageHeader: React.FC = () => {
  const { header: state } = useContext(HeaderContext);

  const { isMobile } = useWindowSize();

  const {
    userAccessRights: {
      SalesFunnels: { IsFunnelCreate },
    },
  } = useNewUserAccessRights();

  return (
    <div className={`${PREFIX}sales-funnels-page-header`}>
      {IsFunnelCreate && (
        <Button
          type="primary"
          onClick={() =>
            typeof state.setIsCreateModalOpen === 'function' &&
            state.setIsCreateModalOpen(true)
          }
        >
          {isMobile ? '+' : CREATE_SALES_FUNNEL}
        </Button>
      )}
    </div>
  );
};
